import SEO from "../components/SEO";
import PageBanner from "../components/layout/PageBanner";
import Container from "../components/layout/Container";

const Terms = () => (
  <main>
    <SEO title="Terms & Conditions" description="Waterfront Cafe website terms and conditions." />
    <PageBanner title="Terms & Conditions" eyebrow="Legal" text="Website usage and booking request terms." image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=80" />
    <section className="section legal-page">
      <Container>
        <h2>Terms and Conditions</h2>
        <p><strong>Last Updated: June 2026</strong></p>
        <p>Welcome to Waterfront Cafe. By accessing and using this website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website.</p>

        <h2>1. About Us</h2>
        <p>This website is operated by <strong>IVI Waterfronts Limited</strong>, trading as Waterfront Cafe.</p>
        <p><strong>Registered Company Number:</strong> 10265263</p>
        <p>
          <strong>Registered Address:</strong><br />
          A4074 Benson Waterfront,<br />
          Wallingford,<br />
          Oxfordshire,<br />
          OX10 6SJ,<br />
          United Kingdom
        </p>
        <p><strong>Email:</strong> <a href="mailto:info@waterfrontcafe.co.uk">info@waterfrontcafe.co.uk</a></p>
        <p><strong>Telephone:</strong> +44 (0) 1491 833 732</p>
        <p>Throughout these Terms and Conditions, references to "Waterfront Cafe", "we", "us", or "our" refer to IVI Waterfronts Limited.</p>

        <h2>2. Website Use</h2>
        <p>You may access and use this website for lawful purposes only.</p>
        <p>You agree not to:</p>
        <ul>
          <li>Use the website in any way that breaches applicable laws or regulations.</li>
          <li>Attempt to gain unauthorised access to any part of the website.</li>
          <li>Introduce viruses, malware, or other harmful technologies.</li>
          <li>Interfere with the operation or security of the website.</li>
          <li>Use automated tools or software to extract data from the website without permission.</li>
        </ul>
        <p>We reserve the right to restrict or terminate access to the website where misuse is identified.</p>

        <h2>3. Information Accuracy</h2>
        <p>We make every reasonable effort to ensure that information published on this website is accurate and up to date.</p>
        <p>However, we do not guarantee that:</p>
        <ul>
          <li>Website content will always be accurate.</li>
          <li>Information will be complete or error-free.</li>
          <li>Website availability will be uninterrupted.</li>
        </ul>
        <p>Menus, prices, opening hours, promotions, events, and services may change without prior notice.</p>

        <h2>4. Reservations and Booking Requests</h2>
        <p>Reservations submitted through our website are considered booking requests and are not confirmed until you receive confirmation from Waterfront Cafe.</p>
        <p>We reserve the right to:</p>
        <ul>
          <li>Refuse or cancel reservations where necessary.</li>
          <li>Modify booking arrangements due to operational requirements.</li>
          <li>Request additional information to confirm reservations.</li>
        </ul>
        <p>Customers are responsible for ensuring that booking details provided are accurate.</p>

        <h2>5. Dietary Requirements and Allergies</h2>
        <p>While we make every effort to accommodate dietary requirements and food allergies, we cannot guarantee that any menu item is completely free from allergens due to the risk of cross-contamination during food preparation.</p>
        <p>Customers with allergies or dietary concerns should inform staff when making a reservation and again when placing orders.</p>
        <p>Waterfront Cafe accepts no liability for allergic reactions where customers fail to disclose relevant dietary information.</p>

        <h2>6. Gift Vouchers and Promotions</h2>
        <p>Where gift vouchers, discounts, promotions, or special offers are available:</p>
        <ul>
          <li>They may be subject to separate terms and conditions.</li>
          <li>They may not be combined with other promotions unless expressly stated.</li>
          <li>Expiry dates may apply.</li>
          <li>We reserve the right to withdraw promotions at any time.</li>
        </ul>

        <h2>7. Intellectual Property</h2>
        <p>All content on this website, including but not limited to:</p>
        <ul>
          <li>Text</li>
          <li>Images</li>
          <li>Logos</li>
          <li>Branding</li>
          <li>Graphics</li>
          <li>Menus</li>
          <li>Design elements</li>
          <li>Website content</li>
        </ul>
        <p>is owned by or licensed to Waterfront Cafe and is protected by applicable intellectual property laws.</p>
        <p>You may not reproduce, distribute, modify, copy, publish, or commercially exploit any website content without prior written permission.</p>

        <h2>8. Third-Party Links</h2>
        <p>This website may contain links to third-party websites, including social media platforms, mapping services, and external providers.</p>
        <p>We do not control these websites and are not responsible for:</p>
        <ul>
          <li>Their content</li>
          <li>Their availability</li>
          <li>Their privacy practices</li>
          <li>Their terms of use</li>
        </ul>
        <p>Accessing third-party websites is done at your own risk.</p>

        <h2>9. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Waterfront Cafe shall not be liable for:</p>
        <ul>
          <li>Indirect or consequential losses.</li>
          <li>Loss of profits, revenue, or business opportunities.</li>
          <li>Loss arising from website unavailability.</li>
          <li>Technical issues beyond our control.</li>
          <li>Reliance on website information.</li>
        </ul>
        <p>Nothing in these Terms excludes liability where exclusion would be unlawful under applicable UK law.</p>

        <h2>10. Website Availability</h2>
        <p>We aim to ensure the website remains available and operational.</p>
        <p>However, we do not guarantee uninterrupted access and may suspend, withdraw, or restrict access to all or part of the website for maintenance, updates, security, or operational reasons.</p>

        <h2>11. Privacy and Cookies</h2>
        <p>Your use of this website is also governed by our:</p>
        <ul>
          <li>Privacy Policy</li>
          <li>Cookie Policy</li>
          <li>GDPRCompliance Statement</li>
        </ul>
        <p>These documents explain how personal information is collected, used, and protected.</p>

        <h2>12. User Submissions</h2>
        <p>Where users submit enquiries, reservation requests, reviews, or messages through the website, they agree that:</p>
        <ul>
          <li>Information provided is accurate.</li>
          <li>Content is not unlawful, offensive, defamatory, or misleading.</li>
          <li>Submissions do not infringe the rights of third parties.</li>
        </ul>
        <p>We reserve the right to remove or ignore inappropriate submissions.</p>

        <h2>13. Changes to These Terms</h2>
        <p>We may update these Terms and Conditions at any time.</p>
        <p>Updated versions will be published on this page and become effective immediately upon publication.</p>
        <p>Continued use of the website after changes are made constitutes acceptance of the updated terms.</p>

        <h2>14. Governing Law</h2>
        <p>These Terms and Conditions shall be governed by and interpreted in accordance with the laws of England and Wales.</p>
        <p>Any disputes arising from or relating to these Terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

        <h2>15. Contact Us</h2>
        <p>If you have any questions regarding these Terms and Conditions, please contact:</p>
        <p><strong>Waterfront Cafe</strong></p>
        <p><strong>Email:</strong> <a href="mailto:info@waterfrontcafe.co.uk">info@waterfrontcafe.co.uk</a></p>
        <p><strong>Telephone:</strong> +44 (0) 1491 833 732</p>
        <p>
          <strong>Address:</strong><br />
          A4074 Benson Waterfront,<br />
          Wallingford,<br />
          Oxfordshire,<br />
          OX10 6SJ,<br />
          United Kingdom
        </p>
        <p><strong>Company Number:</strong> 10265263</p>
      </Container>
    </section>
  </main>
);

export default Terms;
